module.exports = "/assets/packs/images/f4781f865b5d4764926d8ee8cdec7fa1.png";